import layout from '../layout/index.vue'
import blank from '../layout/blank.vue'
export default {
    path: '/dealer',
    name: 'dealer',
    redirect: '/dealer/index',
    meta: {
        type: 'dealer'
    },
    component: layout,
    children: [
        {
            path: 'index',
            name: 'dealer-index',
            meta: {
                type: 'dealer',
                title: '云仓商城首页',
                icon: 'el-icon-s-home',
                hidden: false
            },
            component: () => import('../views/dealer/goods/mall.vue')
        },
        {
            path: 'data-panel',
            name: 'dealer-data-panel',
            meta: {
                type: 'dealer',
                title: '数据面板',
                icon: 'el-icon-s-home',
                hidden: false
            },
            component: () => import('../views/dealer/home/index.vue')
        },
        {
            path: 'goods',
            name: 'dealer-goods',
            meta: {
                type: 'dealer',
                title: '商城',
                icon: 'el-icon-s-goods',
                hidden: false
            },
            component:blank,
            redirect: '/dealer/goods/list',
            children: [
                {
                    path: 'list',
                    name: 'dealer-goods-list',
                    meta: {
                        type: 'dealer',
                        title: '商品列表',
                        hidden: true
                    },
                    component: () => import('../views/dealer/goods/list.vue'),
                },
                {
                    path: 'detail',
                    name: 'dealer-goods-detail',
                    meta: {
                        type: 'dealer',
                        title: '商品详情',
                        hidden: true
                    },
                    component: () => import('../views/dealer/goods/detail.vue'),
                },
                {
                    path: 'takeOrder',
                    name: 'dealer-goods-takeOrder',
                    meta: {
                        type: 'dealer',
                        title: '下单',
                        hidden: true,
                    },
                    component: () => import('../views/dealer/goods/takeOrder.vue'),
                }
            ]
        },
        {
            path:'order',
            name:'dealer-order',
            meta:{
                type: 'dealer',
                title: '订单管理',
                icon: 'el-icon-s-order',
                hidden: false
            },
            component: blank,
            redirect: '/dealer/order/list-lock',
            children:[
                // {
                //     path: 'list',
                //     name: 'dealer-order-list',
                //     meta: {
                //         type: 'dealer',
                //         title: '订单列表',
                //         hidden: true
                //     },
                //     component: () => import('../views/dealer/order/list.vue'),
                // },
                {
                    path: 'list-lock',
                    name: 'dealer-order-list-lock',
                    meta: {
                        type: 'dealer',
                        title: '锁仓列表',
                        hidden: false
                    },
                    component: () => import('../views/dealer/order/list-lock.vue'),
                },
                {
                    path: 'list-take',
                    name: 'dealer-order-list-take',
                    meta: {
                        type: 'dealer',
                        title: '下单列表',
                        hidden: false
                    },
                    component: () => import('../views/dealer/order/list-take.vue'),
                },
                {
                    path: 'list-clear',
                    name: 'dealer-order-list-clear',
                    meta: {
                        type: 'dealer',
                        title: '清算列表',
                        hidden: false
                    },
                    component: () => import('../views/dealer/order/list-clear.vue'),
                },
                // {
                //     path: 'detail',
                //     name: 'dealer-order-detail',
                //     meta: {
                //         type: 'dealer',
                //         title: '订单详情',
                //         hidden: true
                //     },
                //     component: () => import('../views/dealer/order/detail.vue'),
                // },
                {
                    path: 'detail-lock',
                    name: 'dealer-order-detail-lock',
                    meta: {
                        type: 'dealer',
                        title: '锁仓订单详情',
                        hidden: true
                    },
                    component: () => import('../views/dealer/order/detail-lock.vue'),
                },
                {
                    path: 'detail-take',
                    name: 'dealer-order-detail-take',
                    meta: {
                        type: 'dealer',
                        title: '下单订单详情',
                        hidden: true
                    },
                    component: () => import('../views/dealer/order/detail-take.vue'),
                },
                {
                    path: 'detail-clear',
                    name: 'dealer-order-detail-clear',
                    meta: {
                        type: 'dealer',
                        title: '清算订单详情',
                        hidden: true
                    },
                    component: () => import('../views/dealer/order/detail-clear.vue'),
                },
                // {
                //     path: 'liquidation',
                //     name: 'dealer-order-liquidation',
                //     meta: {
                //         type: 'dealer',
                //         title: '清算详情',
                //         hidden: true
                //     },
                //     component: () => import('../views/dealer/order/liquidation.vue'),
                // },
            ]
        },
        {
            path: 'setting',
            name: 'dealer-user',
            meta: {
                type: 'dealer',
                title: '个人设置',
                icon: 'el-icon-s-tools',
                hidden: false
            },
            component: () => import('../views/dealer/setting/index.vue')
        },

    ]
}